<template>
	<div class="kr-placard-list">
		<KRPlacard
			v-for="form in keyResultForms"
			:key="form.formId"
			:disabled="disabled || !form.capabilities.edit"
			:busy="busy"
			:confidence-level="form.confidenceLevel"
			:current-value="form.currentValue"
			:due-date="form.dueDate"
			:last-updated-date="form.lastUpdatedDate"
			:last-updated-ago="form.lastUpdatedAgo"
			:name="form.name"
			:owner-avatar="form.ownerAvatar"
			:owner-name="form.ownerName"
			:owner-email="form.ownerEmail"
			:pacing="form.pacing"
			:progress="form.progress"
			:target-value="form.targetValue"
			:type="form.type"
			@click="onKeyResultFormSelected( form )"
		/>
	</div>
</template>

<script>
import KRPlacard from "./KRPlacard";

export default {
	name: "KRPlacardList",
	emits: [ "select", ],
	components: {
		KRPlacard,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		busy: {
			type: Boolean,
			default: false,
		},
		keyResultForms: {
			type: Array,
			required: true,
		},
	},
	methods: {
		onKeyResultFormSelected( form ) {
			if ( this.disabled ) {
				return;
			}
			const { formId, keyResultId, } = form;
			this.$emit( "select", { formId, keyResultId, } );
		},
	},
};
</script>

<style lang="scss" scoped>
.kr-placard-list {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 1rem;
}
</style>
